import { Tooltip } from 'components/Tooltip'
import React from 'react'
import { theme } from 'styles/theme/hav-theme'
import { TagStyled, Container } from './styles'
export interface TagProps {
  background?: string
  children: React.ReactNode
  tooltipLabel?: string
}

export const Tag = ({
  children,
  tooltipLabel = '',
  background = theme.colors.alert.warning.main
}: TagProps) => {
  return (
    <Tooltip title={tooltipLabel} placement="top" arrow>
      <TagStyled background={background}>
        <Container>{children}</Container>
      </TagStyled>
    </Tooltip>
  )
}
